export default __webpack_public_path__ + "static/media/avrLogo.c0508622.png";